import { formatDate } from "@angular/common";

export class JobFollowUpDto {
  id: string;
  jobId: string;
  statusId: string;
  comment: string;
  method: string;
  type: string;
  priority: string;
  closed: number;
  followUpBy: string;
  followUpDate: Date;
  loggedDate: Date;
  closedDate: Date;
  closedBy: string;
  contact: string;
}

export function formatFollowUpDate(date: Date): string {
  const then = +date;
  const now = new Date().valueOf();
  const hours = Math.abs((now - then) / 36e5);
  if (hours <= 24) return formatDate(date, "HH:mm", "en-ZA");
  if (hours / 24 <= 7) return formatDate(date, "EEEEEE':'HH", "en-ZA");
  if (hours / 24 <= 365) return formatDate(date, "MMMdd", "en-ZA");
  return formatDate(date, "y", "en-ZA");
}
